import React from "react";

class ReadVaultFunction extends React.Component {
  state = { dataKey: null };

  componentDidMount() {
    const { drizzle, drizzleState } = this.props;
    const contract = drizzle.contracts.VaultSystem;
    // let drizzle know we want to watch the `weiPerSpx` method	

	var dataKey
	
	if (typeof this.props.dictkey === 'undefined') {
		dataKey = contract.methods[this.props.value].cacheCall();
	} else {
		dataKey = contract.methods[this.props.value].cacheCall(this.props.dictkey);
		
	}
		
	this.setState({ dataKey });


    // save the `dataKey` to local component state for later reference
    
	
	
	// Inject Initalization of SPXToken Here
	
	
  }

  render() {
    // get the contract state from drizzleState
    const { VaultSystem } = this.props.drizzleState.contracts;
    // using the saved `dataKey`, get the variable we're interested in
    // const myfunctionvalue = eval('VaultSystem.' + this.props.value + '[this.state.dataKey]');
	const myfunctionvalue = VaultSystem[this.props.value][this.state.dataKey]
    // if it exists, then we display its value
	
	if (myfunctionvalue) {
		var myfunctionvalue_value = myfunctionvalue.value
		if(this.props.decimalsToDivide) {
			myfunctionvalue_value /= 10**this.props.decimalsToDivide
		}
	}
	
	
	
    return (
	<> {myfunctionvalue && myfunctionvalue_value} </>);
  }
}

export default ReadVaultFunction;